export default __webpack_public_path__ + "static/media/ag_9.e690084d.wav";